<template>
  <div>
    <div v-if="expanded" style="white-space: normal; word-break: break-word;">
      {{ text }}
    </div>
    <div v-else class="text-truncate" style="max-width: 100%;">
      {{ text }}
    </div>
    <a
      v-if="isLong"
      href="#"
      class="grey--text"
      style="font-size: 11px;"
      @click.prevent="expanded = !expanded"
    >
      {{ expanded ? 'Show less' : 'Show more' }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'ExpandableText',
  props: {
    text: { type: String, default: '' },
    threshold: { type: Number, default: 100 }
  },
  data() {
    return {
      expanded: false
    }
  },
  computed: {
    isLong() {
      return (this.text || '').length > this.threshold
    }
  }
}
</script>
